<ngx-datatable
    [rows]="rows"
    [columns]="columns"
    [sortType]="SortType.multi"
    [columnMode]="ColumnMode.force"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="50"
    [limit]="10"
>
</ngx-datatable>